// Base Javascript
// ============================================

// Suppress Lint semicolon warnings
/* jshint asi: true */

$(window).load(function(){
	$('.light-gallery-images').packery({
      itemSelector: '.inner'
    });
})  



jQuery(document).ready(function($) {
	var e = 0;
	
	$('.fader').each(function() {
		$(this).delay(e).animate({opacity:1},200);
		e += 100;
	});

	// ============================================
	// Galleries
	// ============================================

	// Video

	function doLightGallery() {
		
        $('.home-gallery').lightGallery({
			download:false,
			selector:'.slide-video',
			showThumbByDefault:0,
			videoMaxWidth: '90%',
			zoom:1,
			loadVimeoThumbnail:1,
			controls:1,
			thumbnail:1,
			counter:0,
			mode:'lg-fade',
			vimeoPlayerParams: {
					byline : 0,
					portrait : 0,
					color : 'A90707'
				}
		});

		$('.director-gallery').lightGallery({
			download:false,
			selector:'.slide-video',
			showThumbByDefault:0,
			videoMaxWidth: '90%',
			zoom:1,
			loadVimeoThumbnail:1,
			controls:1,
			thumbnail:1,
			counter:0,
			mode:'lg-fade',
			vimeoPlayerParams: {
					byline : 0,
					portrait : 0,
					color : 'A90707'
				}
		});

		$('.director-single').lightGallery({
			download:false,
			selector:'.item',
			showThumbByDefault:0,
			videoMaxWidth: '90%',
			zoom:1,
			loadVimeoThumbnail:1,
			controls:1,
			thumbnail:1,
			counter:0,
			mode:'lg-fade',
			vimeoPlayerParams: {
					byline : 0,
					portrait : 0,
					color : 'A90707'
				}
		});

		$('.director-single').lightGallery({
			download:false,
			selector:'.image-gal',
			showThumbByDefault:0,
			videoMaxWidth: '90%',
			zoom:1,
			loadVimeoThumbnail:1,
			controls:1,
			thumbnail:1,
			counter:0,
			mode:'lg-fade',
			vimeoPlayerParams: {
					byline : 0,
					portrait : 0,
					color : 'A90707'
				}
		});
	}

	doLightGallery();

	$('.dynamic').on('click', function() {
 		src = $(this).data('src');
	    $(this).lightGallery({
	        dynamic: true,
			download:false,
			selector:'.item',
			showThumbByDefault:0,
			videoMaxWidth: '90%',
			zoom:1,
			loadVimeoThumbnail:1,
			controls:1,
			thumbnail:1,
			counter:0,
			mode:'lg-fade',
			vimeoPlayerParams: {
					byline : 0,
					portrait : 0,
					color : 'A90707'
				},
	        dynamicEl: [{
	            "src": src
	        }]
	    });
	});

	$('.dynamic-images').on('click', function() {
		src = $(this).data('src');

		source_array = src.split(',');
		source_array.pop();

		var elements = [];
		for (var i = 0; i<source_array.length; i++) {
			elements.push({
				src: source_array[i],
				thumb: source_array[i]
			})
		}
		
		$(this).lightGallery({
			dynamic:true,
			download:false,
			controls:1,
			thumbnail:1,
			mode:'lg-fade',
			dynamicEl: elements
		})
	});

	// ============================================
	// Images
	// ============================================

	$('.light-gallery-images').lightGallery({
		selector: '.gallery-item',
		mode: 'lg-fade',
		thumbnail:0,
		title:0
	});

	// ============================================
	// Dynamic gallery
	// ============================================

	$('.dynamic-image').on('click', function() {

		var els = $( this ).data( "elements" );
			els = els.trim();
			els = els.split(',');
			els_final = els.pop();

		var thumb = $( this ).data( "thumbs" );
			thumb = thumb.trim();
			thumb = thumb.split(',');
			thumb_final = thumb.pop();

		jsonStr = [];
		for (i = 0; i < els.length; i++) {
			jsonStr.push({
				"src" : els[i],
				"thumb" : thumb[i]
			})
		}

		$(this).lightGallery({
	        dynamic: true,
			thumbnail:1,
			dynamicEl: jsonStr
		});

	});

	// ============================================
	// Element matching (matchheight.js)
	// ============================================

	$('.biog-match').matchHeight({
		byRow: true,
    	property: 'height',
	});

	$('.staff-match').matchHeight({
		byRow: true,
    	property: 'height',
	})

	// ============================================
	// Navbar animated hamburger
	// ============================================

	$('.navbar-toggle').click(function() {
        $(this).children('div').toggleClass('active');
        $(this).toggleClass('active');
    });

	// ============================================
	// Carousels
	// ============================================

	var fadespeed = 500;
	var slide_delay = 4000;

	basic_carousel = $('.basic-carousel');
	advanced_carousel = $('.advanced-carousel');
  	dynamic_carousel = $('.dynamic-carousel')
	director_carousel = $('.director-carousel');




    $(dynamic_carousel).on('cycle-bootstrap', function(e, opts) {
        var max = 0;

        $(this).find(opts.slides).each(function(el) {
            var h = $(this).height();

            if (h > max) {
                max = h;
			}
        });

        if (max > 0) {
            $(this).css('height', max);
		}
		
		
    }).on('cycle-post-initialize', function(e, opts) {

		var that = this;

		setTimeout(function() {
			$(that).css('height', 'auto');
		}, 0);

		

	}).cycle({
		slides: "> .slide",
		fx: "fade",
		timeout:slide_delay,
		pager: '.custom-page',
		swipe:false,
		speed:fadespeed,
		pauseOnHover:true,
		pagerTemplate: '<div class="circle"><span class="circle-scribble"></span></div>',
		pagerEventBubble: true,
		loader:"wait",
		updateView:1
	});

	dynamic_carousel.on('cycle-pre-initialize', function(event, optionHash) {
		$('.inner-smear').hide()
			.delay(fadespeed)
	});

	// all subsequent

	dynamic_carousel.on('cycle-after', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag){
		dynamic_carousel.cycle('pause');
		
		
		$('.inner-smear').velocity({
			opacity:"1"
		}, {
			duration:fadespeed,
			complete:function() {
				dynamic_carousel.cycle('resume');
				
			}
		});
	});

	dynamic_carousel.on('cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag){
		

		$('.inner-smear').velocity({
			opacity:"0"
		}, {
		duration:fadespeed,
		complete:function() {
			dynamic_carousel.cycle('resume');
			
		}
		});
	});

	$(director_carousel).on('cycle-bootstrap', function(e, opts) {
		var max = 0;

		$(this).find(opts.slides).each(function(el) {
			var h = $(this).height();

			if (h > max) {
				max = h;
			}
		});

		if (max > 0) {
			$(this).css('height', max);
		}
	}).on('cycle-post-initialize', function(e, opts) {

	var that = this;

	setTimeout(function() {
		$(that).css('height', 'auto');
	}, 0);

	}).cycle({
		slides: "> .slide",
		fx: "fade",
		timeout:slide_delay,
		pager: '.custom-page',
		swipe:false,
		speed:fadespeed,
		pauseOnHover:true,
		pagerTemplate: '<div class="circle"><span class="circle-scribble"></span></div>',
		loader:"wait",
		updateView:1
	
	});

	director_carousel.on('cycle-pre-initialize', function(event, optionHash) {
		$('.overlay-text').hide()
			.delay(fadespeed)
	});

	// all subsequent

	director_carousel.on('cycle-after', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag){
		director_carousel.cycle('pause');
		director_carousel.hide().show();
		
		$('.overlay-text').hide().show().velocity({
			opacity:"1"
		}, {
			duration:fadespeed,
			complete:function() {
				director_carousel.cycle('resume');
				
			
			}
		});
	});

	director_carousel.on('cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag){
		director_carousel.hide().show();

		$('.overlay-text').hide().show().velocity({
		opacity:"0"
		}, {
		duration:fadespeed,
		complete:function() {
			director_carousel.cycle('resume');
			
			
		}
		});
	});

	$('.custom-page').hover(function(){
		dynamic_carousel.cycle('pause');
		basic_carousel.cycle('pause');
		director_carousel.cycle('pause');
		advanced_carousel.cycle('pause');

	}, function(){
		dynamic_carousel.cycle('resume');
		basic_carousel.cycle('resume');
		director_carousel.cycle('resume');
		advanced_carousel.cycle('resume');
	})

  
    // Archive

    $('.archive-button-show').on('click', function(e){
		e.preventDefault();
		$('.video-archive-list').slideDown(1000);
		$(this).hide();
		$('.archive-button-hide').show();
		doLightGallery();
        body_pad = $('.main-nav').innerHeight();

		$('html, body').animate({
        	scrollTop: $('#archive').offset().top// - body_pad
    	}, 1000);

		$('.archive-hr').animate({opacity:1}, 2000);
	})

	$('.archive-button-hide').on('click', function(e){
		e.preventDefault();
		$('.video-archive-list').slideUp(1000);
		$(this).hide();
		$('.archive-button-show').show();
		$('.archive-hr').animate({opacity:0}, 2000);

	})

    // image gallery isotope




});

// Page loader

$(window).load(function() {
    $('.loading').hide();
	$('.page-container').show();
});

// Google map API



(function($) {

/*
*  new_map
*/

	function new_map($el) {
		var $markers = $el.find('.marker');
		var args = {
			zoom: 18,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			styles: [
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e9e9e9"
						}, {
							"lightness": 17
						}
					]
				}, {
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						}, {
							"lightness": 20
						}
					]
				}, {
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						}, {
							"lightness": 17
						}
					]
				}, {
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						}, {
							"lightness": 29
						}, {
							"weight": 0.2
						}
					]
				}, {
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}, {
							"lightness": 18
						}
					]
				}, {
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}, {
							"lightness": 16
						}
					]
				}, {
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						}, {
							"lightness": 21
						}
					]
				}, {
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dedede"
						}, {
							"lightness": 21
						}
					]
				}, {
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						}, {
							"color": "#ffffff"
						}, {
							"lightness": 16
						}
					]
				}, {
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						}, {
							"color": "#333333"
						}, {
							"lightness": 40
						}
					]
				}, {
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				}, {
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f2f2f2"
						}, {
							"lightness": 19
						}
					]
				}, {
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#fefefe"
						}, {
							"lightness": 20
						}
					]
				}, {
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#fefefe"
						}, {
							"lightness": 17
						}, {
							"weight": 1.2
						}
					]
				}
			]

		};

		// create map
		var map = new google.maps.Map($el[0], args);
		map.markers = [];
		$markers.each(function() {

			add_marker($(this), map);

		});

		center_map(map);
		return map;

	}

/*
*  add_marker
*/

	function add_marker($marker, map) {

		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		// create marker
		var marker = new google.maps.Marker({
			map: map,
			position: latlng,
			icon: {
				url: marker_url,
				size: new google.maps.Size(100,100),
				origin: new google.maps.Point(0,0),
				anchor: new google.maps.Point(40,50),
				scaledSize: new google.maps.Size(50,50)
			}
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			// create info window
			var infowindow = new google.maps.InfoWindow({content: $marker.html()});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open(map, marker);
			});
		}
	}

/*
*  center_map
*/

	function center_map(map) {

		var bounds = new google.maps.LatLngBounds();

		$.each(map.markers, function(i, marker) {

			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

			bounds.extend(latlng);

		});

		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());
			map.setZoom(18);
		} else {
			map.fitBounds(bounds);
		}

		google.maps.event.addDomListener(window, "resize", function() {
			google.maps.event.trigger(map, "resize");
			map.setCenter( bounds.getCenter() );
		});

	}

	var map = null;

	$(document).ready(function() {
		$('.acf-map').each(function() {
			map = new_map($(this));
		});
	});

})(jQuery);
